export class PerfilConstant {
    public static PERFIL_AUXILIAR: String = 'AUXILIAR';
    public static PERFIL_DELEGADO: String = 'DELEGADO';
    public static PERFIL_ASESOR: String = 'ASESOR';
    public static PERFIL_COMERCIAL: String = 'COMERCIAL';
    public static PERFIL_COMERCIAL_DELEGADO: String = 'COMERCIALDELEGADO';
    public static PERFIL_SALUD_PROVEDOR_DELEGADO: String = 'SALUDPROVEEDORDELEGADO';
}



// WEBPACK FOOTER //
// ./src/app/contants/perfil.constant.ts